import React, { memo, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Button, Form, Input, Modal, Row, Select, Space } from 'antd'
import { DOCUMENT_TYPE } from '../../constants'
import { inject, observer } from 'mobx-react'
import Message from '../../components/common/Message'

const AuthoritiesActionModal = props => {
  const {
    payloadModal,
    handleCloseModal,
    authorityStore,
    handleSetValueFilter,
    tabActive,
    createMessage,
  } = props

  const [message, setMessage] = useState('')
  const [openMessage, setOpenMessage] = useState(false)
  const [severity, setSeverity] = useState('')

  const createMessageV2 = (message, openMessage, severity) => {
    setMessage(message)
    setOpenMessage(openMessage)
    setSeverity(severity)
  }

  const [form] = Form.useForm()

  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if (!payloadModal.updatePayLoad) return
    form.setFieldsValue({
      type: payloadModal.updatePayLoad.type,
      name: payloadModal.updatePayLoad.name,
    })
  }, [payloadModal])

  useEffect(() => {
    if (payloadModal.isCreate) {
      form.setFieldsValue({
        type: tabActive,
      })
    }
  }, [tabActive])

  const onFinish = async values => {
    try {
      let messageSuccess
      setIsLoading(true)
      if (payloadModal.isCreate) {
        await authorityStore.createAuthority(values)
        messageSuccess = 'Tạo cơ quan ban hành thành công!'
      } else {
        await authorityStore.updateAuthority(
          payloadModal.updatePayLoad?.id,
          values
        )
        messageSuccess = 'Chỉnh sửa cơ quan ban hành thành công!'
      }
      await authorityStore.getAuthorityIssueds()
      handleSetValueFilter && handleSetValueFilter(payloadModal.isCreate)
      handleCancel()
      createMessage(messageSuccess, true, 'success')
    } catch (err) {
      console.log(err)
      createMessageV2(err.vi || 'Đã có lỗi xảy ra!', true, 'error')
    } finally {
      setIsLoading(false)
    }
  }

  const handleCancel = () => {
    handleCloseModal()
    setTimeout(() => {
      form.resetFields()
    }, 100)
  }

  return (
    <Modal
      open={payloadModal.status}
      footer={null}
      onCancel={handleCancel}
      zIndex={9999}
      title={
        payloadModal.isCreate
          ? 'Tạo mới cơ quan ban hành'
          : 'Chỉnh sửa cơ quan ban hành'
      }>
      <Form
        form={form}
        layout={'vertical'}
        onFinish={onFinish}
        initialValues={{
          type: tabActive,
        }}>
        <Form.Item
          name="type"
          label="Loại cơ quan ban hành"
          rules={[{ required: true, message: 'Vui lòng chọn loại văn bản!' }]}>
          <Select
            disabled={
              !payloadModal.isCreate || props.disabledAuthoritiesTypePicker
            }>
            <Select.Option value={DOCUMENT_TYPE.INCOMING}>
              Văn bản đến
            </Select.Option>
            <Select.Option value={DOCUMENT_TYPE.OUTGOING}>
              Văn bản đi
            </Select.Option>
          </Select>
        </Form.Item>

        <Form.Item
          label={'Tên cơ quan ban hành'}
          name={'name'}
          rules={[
            {
              required: true,
              message: 'Vui lòng nhập tên cơ quan ban hành!',
              whitespace: true,
            },
          ]}>
          <Input placeholder={'Nhập tên cơ quan ban hành'} />
        </Form.Item>
        <Row justify={'end'} style={{ marginTop: 20 }}>
          <Space>
            <Button onClick={handleCancel}>Hủy</Button>
            <Button
              style={{
                color: '#fff',
                backgroundColor: '#1677ff',
              }}
              type={'primary'}
              htmlType={'submit'}
              loading={isLoading}>
              {payloadModal.isCreate ? 'Tạo mới' : 'Cập nhật'}
            </Button>
          </Space>
        </Row>
      </Form>
      <Message
        message={message}
        openMessage={openMessage}
        severity={severity}
        closeMessage={() => {
          setOpenMessage(false)
        }}
      />
    </Modal>
  )
}

AuthoritiesActionModal.propTypes = {
  payloadModal: PropTypes.object.isRequired,
  handleCloseModal: PropTypes.func.isRequired,
  handleSetValueFilter: PropTypes.func,
  disabledAuthoritiesTypePicker: PropTypes.bool,
}

export default memo(
  inject(
    'loadingAnimationStore',
    'authenticationStore',
    'authorityStore',
    'commonStore'
  )(observer(AuthoritiesActionModal))
)
